import React from 'react';
import { Badge, Group, Paper, Progress, ScrollArea, Stack, Text } from '@mantine/core';

export function ActivityLog({ log }) {
  if (!log || log.length === 0) return null;
  return (
    <Paper withBorder p="md">
      <Text size="sm" fw={500} mb="xs">
        Activity log
      </Text>
      <ScrollArea.Autosize mah={360}>
        <Stack gap={4}>
          {log.map((row, i) => (
            <Group key={i} gap="xs" align="flex-start" wrap="nowrap">
              <Text size="xs" c="dimmed" style={{ width: 70 }}>
                {row.ts}
              </Text>
              <Badge
                size="xs"
                color={
                  row.level === 'error'
                    ? 'red'
                    : row.level === 'warning'
                      ? 'yellow'
                      : row.level === 'success'
                        ? 'green'
                        : 'blue'
                }
                variant="light"
                style={{ width: 76, textAlign: 'center' }}
              >
                {row.level}
              </Badge>
              <Text size="xs" style={{ flex: 1, wordBreak: 'break-word' }}>
                {row.message}
              </Text>
            </Group>
          ))}
        </Stack>
      </ScrollArea.Autosize>
    </Paper>
  );
}

export function ProgressBar({ done, total, running, label = 'Progress' }) {
  if (total === 0 && !running) return null;
  const percent = total === 0 ? 0 : Math.round((done / total) * 100);
  return (
    <Paper withBorder p="md" mb="md">
      <Group justify="space-between" mb="xs">
        <Text size="sm" fw={500}>
          {label} — {done} / {total} items
        </Text>
        <Badge color={running ? 'blue' : 'gray'}>
          {running ? 'Running' : 'Idle'}
        </Badge>
      </Group>
      <Progress value={percent} animated={running} />
    </Paper>
  );
}

export function useActivityLog() {
  const [log, setLog] = React.useState([]);
  const append = React.useCallback((level, message) => {
    setLog((prev) => [
      ...prev,
      { level, message, ts: new Date().toLocaleTimeString() },
    ]);
  }, []);
  const reset = React.useCallback(() => setLog([]), []);
  return { log, append, reset };
}
